import styled from "styled-components";

export const FeedbackFormSubmitButton =
  styled.button`
    && {
      ${((props) => props?.theme?.themeConfig?.chatMessages?.botMessage?.feedback?.feedbackForm?.submitButton?.styles)}
    }
  `;